<template>
  <div>
    <OneBoxDefault
      :dev-domains="devDomains"
      area-list-title="日本各地の天気予報"
      :invisible-contents="invisibleContents"
      :bread-crumb-list="breadCrumbList"
      :is-web-view-prop="isWebViewFlag"
    >
      <div
        v-if="isWebViewFlag"
        id="ads-atf"
        class="ads-atf"
      />
      <slot name="main" />

      <template #main-bottom>
        <slot name="main-bottom" />
      </template>

      <template #ads-btf>
        <!-- Subの一番上(PCのみ) -->
        <div
          v-if="!isWebViewFlag"
          id="ads-btf1-pc"
          class="ads-btf1-pc"
        />
        <div v-else />
      </template>

      <template #ads-atf>
        <!-- WEBのときはデフォルトのads-aftを使う、アプリの場合は高さゼロ -->
        <div
          v-if="isWebViewFlag"
          style="display: none;"
        />
      </template>

      <!-- 設定上、位置の番号と広告の番号が異なってしまう -->
      <template #ads-btf2>
        <!-- アメダスランキンとお天気ニュースの間(SPのみ) -->
        <div
          v-if="!isWebViewFlag"
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
      </template>

      <template #ads-btf3>
        <!-- 防災・減災メニューの下(共通) -->
        <div
          v-if="!isWebViewFlag"
          id="ads-btf3-pc"
          class="ads-btf3-pc"
        />
        <div
          v-if="!isWebViewFlag"
          id="ads-btf3-sp"
          class="ads-btf3-sp"
        />
      </template>

      <template #ads-btm>
        <div
          v-if="isWebViewFlag"
          style="display: none;"
        />
      </template>
    </OneBoxDefault>
    <StickyAd />
  </div>
</template>

<script setup>
import { OneBoxDefault } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/index'

const runtimeConfig = useRuntimeConfig()
const EnvDevDomains = runtimeConfig.public.devdomains
const devDomains = EnvDevDomains ? JSON.parse(EnvDevDomains) : null

const { $ads: ads } = useNuxtApp()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const invisibleContents = isWebViewFlag ? ['amedas', 'arealist', 'news', 'sidemenu'] : []

defineProps({
  breadCrumbList: {
    type: Array,
    default: () => ([])
  }
})

onMounted(() => {
  ads.init(getAdConfig(isWebViewFlag ? 'app' : 'web'))
})
</script>

<style scoped>
.ads-atf {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
}

.ads-btf1-pc {
  min-height: 250px;
}

.ads-btf1-sp {
  min-height: 50px;
  margin: 15px auto 5px;
}
.ads-btf3-pc {
  min-height: 50px;
  margin: 15px auto 5px;
}
.ads-btf3-sp {
  min-height: 50px;
  margin: 15px auto 5px;
}
</style>
